import React, {FunctionComponent} from 'react';
import {Page} from 'b302-frontend-library';
import {useQuery} from '@tanstack/react-query';

import CompareContent, {useCompareParams} from './CompareContent';
import {useUniversityFindQueryConfig} from '../../../query/University/Query';
import {useCompareUniversitiesQueryConfig} from '../../../query/Compare/Query';

const Compare: FunctionComponent = () => {
    const [universityIds] = useCompareParams();

    const [universityFindConfig] = useUniversityFindQueryConfig(universityIds);
    const [compareConfig] = useCompareUniversitiesQueryConfig(universityIds);

    const universityFindQuery = useQuery(universityFindConfig);
    const compareQuery = useQuery(compareConfig);

    return (
        <Page className={'compare-home-page'}>
            {(universityFindQuery.data && compareQuery.data) &&
                <CompareContent
                    universities={universityFindQuery.data}
                    compareResponse={compareQuery.data} />
            }
        </Page>
    );
};

export default Compare;
